import { render } from "./KutipanKeseluruhanKoding.vue?vue&type=template&id=08b77088"
import script from "./KutipanKeseluruhanKoding.vue?vue&type=script&lang=js"
export * from "./KutipanKeseluruhanKoding.vue?vue&type=script&lang=js"

import "./KutipanKeseluruhanKoding.vue?vue&type=style&index=0&id=08b77088&lang=css"
import "./KutipanKeseluruhanKoding.vue?vue&type=style&index=1&id=08b77088&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__